<script>
	import { goto, ready } from '@roxi/routify';
	import { getData, getGETAPILink, postFormData } from "../helpers.js";
	import Navbar from "../components/Navbar.svelte";
	import Footer from "../components/Footer.svelte";

	let subscriptionType = 2
	let subscriptionTypeError = '';
	let subscriptionTypePromise = getData('user/subscription-type');
	subscriptionTypePromise.then(response => response.json())
	.then(ret_json => {
		if (ret_json.status === 'success') {
			subscriptionType = ret_json.subscription_type;
		} else {
			subscriptionTypeError = '<An Unknown Error Occured>';
		}
	});

	Promise.allSettled([subscriptionTypePromise])
	.then(() => {
		// this is not SSR, so it doesn't actually do anything. Go figure. - HC
		$ready();
	});

	// mailto silently fails on machines with no mail handler, so clicking the
	// Enterprise link also reveals the address with a copy fallback.
	let showEmail = false;
	let copied = false;
	function copyEmail() {
		navigator.clipboard.writeText('support@paloaltodatagroup.com');
		copied = true;
		setTimeout(() => { copied = false; }, 2000);
	}

	let subscriptionUpdateForm;
	let passwordError = '';
	// handle login form submission and response
	function handleUpdateSubscription() {
		let res = postFormData('stripe/change-subscription', subscriptionUpdateForm);
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				$goto('/dashboard');
			} else if (ret_json.status === 'error') {
				let errors = ret_json.error;
				console.log(errors);
				passwordError = errors.password ? errors.password[0] : '';
				subscriptionTypeError = errors.subscription_type ? errors.subscription_type[0] : '';
			}
		});
	}
</script>

<main class=background>
	<Navbar/>
	<div class="lg:mx-64 md:mx-32 sm:mx-10 mx-2 pb-20">
		<div class="mx-auto mt-10">
			<div class="max-w-xl mx-auto p-16 rounded-md shadow-lg bg-white bg-opacity-50">
				<p class="text-2xl font-semibold text-blue-900 mb-4">Update Subscription</p>
				<form method="POST" class="flex-col h-full relative box-border" bind:this={subscriptionUpdateForm} on:submit|preventDefault={handleUpdateSubscription}>
					<div class="flex flex-col space-y-4 text-xl h-full box-border">
						<a href="mailto:support@paloaltodatagroup.com" class="py-2 text-center rounded-md border border-gray-300"
							on:click={() => showEmail = true}>
							Enterprise (Contact Us)
						</a>
						{#if showEmail}
							<div class="flex items-center gap-2 text-sm bg-gray-100 rounded-md px-2 py-1">
								<span class="select-all grow">support@paloaltodatagroup.com</span>
								<button type="button" on:click={copyEmail}
									class="px-2 py-0.5 rounded border border-gray-300 bg-white text-gray-600 hover:bg-gray-200 cursor-pointer">
									{copied ? 'Copied' : 'Copy'}
								</button>
							</div>
						{/if}
						<input id="monthly-subscription" tabindex="0" type="radio" bind:group={subscriptionType} name="sub_type" value={"MONTHLY"}>
						<label for="monthly-subscription" class="radio-label">
							$79.95 per Month
						</label>
						<input id="per-file-subscription" type="radio" bind:group={subscriptionType} name="sub_type" value={"PER_FILE"}>
						<label for="per-file-subscription" class="radio-label">
							10¢ per File
						</label>
						<input id="cancel-subscription" type="radio" bind:group={subscriptionType} name="sub_type" value={"NONE"}>
						<label for="cancel-subscription" class="radio-label">
							Cancel Subscription
						</label>
						<p class='error-text {subscriptionTypeError === '' ? 'hidden' : ''}'>{subscriptionTypeError}</p>
						<div class='input'>
							<div class="relative">
								<input id="password" name="password" type="password" placeholder="Verify Password" class="peer z-20 placeholder:text-transparent {passwordError === '' ? '' : 'border-red-600'}"/>
								<label for="password" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Verify Password</label>							
							</div>
								<p class='error-text {passwordError === '' ? 'hidden' : ''}'>{passwordError}</p>
						</div>
						<div class="flex flex-row justify-between pt-4">
							<a class="w-2/5 text-lg font-sans" href="/user-info-menu">
								<button class="w-full pb-2 pt-1 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
									Back
								</button>
							</a>
							<input type="submit" value="Confirm"
								class="w-2/5 pb-2 pt-1 text-xl !px-0 rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
						</div>
					</div>
				</form>
			</div>
		</div>
		<Footer/>
	</div>
</main>

<style>
	main.background { 
		background-color:theme("colors.gray.100");
	}
	.input-field {
		@apply rounded-md shadow-sm font-thin py-1 px-2;
	}

	input[type="radio"] {
		@apply hidden;
	}
	label.radio-label {
		@apply py-2 text-center rounded-md cursor-pointer border border-gray-300;
	}
	label.radio-label:hover {
		@apply bg-blue-200;
	}
	input:checked + label {
		@apply bg-blue-300 text-gray-900;
	}
</style>